/* eslint-disable no-plusplus */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-param-reassign */
/* eslint-disable no-underscore-dangle */
/* eslint-disable max-len */

import { fabric } from 'fabric';
import { generateId } from '../../utils';
import { FABRIC_CUSTOM_OBJECT, MINIMUM_SIZE_SCALING } from '../../utils/constants';

const EPS = 3;

fabric.RectTextSVG = fabric.util.createClass(fabric.Rect, {
  initialize(options) {
    options || (options = {});
    this.callSuper('initialize', options);
    this.set('name', FABRIC_CUSTOM_OBJECT.rectTextSVG);
    this.set('textStyle', { ...options.textStyle });
    this.set('pathStyle', { ...options.pathStyle });
    this.set('textAlignHorizontal', options.textAlignHorizontal);
    this.set('textAlignVertical', options.textAlignVertical);
    this.set('id', options.id || generateId());
    this.set('type', FABRIC_CUSTOM_OBJECT.rectTextSVG);
    this.on('scaling', () => {
      const width = this.width * this.scaleX;
      const height = this.height * this.scaleY;
      if (width <= MINIMUM_SIZE_SCALING || height <= MINIMUM_SIZE_SCALING) return;
      this.set({
        scaleX: 1,
        scaleY: 1,
        width,
        height,
        flipX: false,
        flipY: false,
      });
      this.setCoords();
    });
  },
  toObject() {
    this.updateClipPath();
    return fabric.util.object.extend(this.callSuper('toObject'), {
      id: this.get('id'),
      textStyle: this.get('textStyle'),
      pathStyle: this.get('pathStyle'),
      textAlignHorizontal: this.get('textAlignHorizontal'),
      textAlignVertical: this.get('textAlignVertical'),
    });
  },
  updateTextStyle() {
    const { width, height, textStyle, rx, ry } = this;
    let clnTextStyle = { ...textStyle };
    clnTextStyle.width = width - EPS - parseInt(rx);
    switch (clnTextStyle.textAlign) {
      case 'center':
        this.set({ textAlignHorizontal: 'center' });
        break;
      case 'left':
        this.set({ textAlignHorizontal: 'left' });
        break;
      case 'right':
        this.set({ textAlignHorizontal: 'right' });
        break;
      case 'top':
        this.set({ textAlignVertical: 'top' });
        break;
      case 'middle':
        this.set({ textAlignVertical: 'middle' });
        break;
      case 'bottom':
        this.set({ textAlignVertical: 'bottom' });
        break;
      default:
        break;
    }
    clnTextStyle.textAlign = this.textAlignHorizontal;
    clnTextStyle.originY = this.textAlignVertical;
    if (clnTextStyle.originY === 'middle') clnTextStyle.originY = 'center';
    clnTextStyle.originX = 'center';
    clnTextStyle.left = 0;
    switch (clnTextStyle.originY) {
      case 'top':
        clnTextStyle.top = -height / 2 + EPS + parseInt(ry) / 5;
        break;
      case 'bottom':
        clnTextStyle.top = height / 2 - EPS - parseInt(ry) / 5;
        break;
      case 'center':
        clnTextStyle.top = 0;
        break;
      default:
        break;
    }
    this.set('textStyle', clnTextStyle);
  },
  createComponents() {
    this.updateTextStyle();
    const text = new fabric.Textbox(this.textStyle.text, {
      ...this.textStyle,
      objectCaching: false,
    });
    this.setCoords();
    let { pathStyle } = this;
    if (pathStyle.deltaX + (pathStyle.width * pathStyle.scaleX) / 2 > this.width)
      pathStyle = { ...pathStyle, deltaX: this.width - (pathStyle.width * pathStyle.scaleX) / 2 };
    if (pathStyle.deltaY + (pathStyle.height * pathStyle.scaleY) / 2 > this.height)
      pathStyle = { ...pathStyle, deltaY: this.height - (pathStyle.height * pathStyle.scaleY) / 2 };
    const searchIcon = new fabric.Path(this.pathStyle.path, {
      width: this.pathStyle.width,
      height: this.pathStyle.height,
      fill: this.pathStyle.fill,
      strokeWidth: this.pathStyle.strokeWidth,
      stroke: this.pathStyle.stroke,
      opacity: this.pathStyle.opacity,
      scaleX: this.pathStyle.scaleX || 1,
      scaleY: this.pathStyle.scaleY || 1,
      angle: this.pathStyle.angle || 0,
      flipX: this.pathStyle.flipX || false,
      flipY: this.pathStyle.flipY || false,
      padding: this.pathStyle.padding || 10,
      top: text.getCenterPoint().y,
      left: text.width - this.width / 2 - EPS,
      originX: 'center',
      originY: 'center',
      objectCaching: false,
    });
    return { text, searchIcon };
  },
  updateClipPath: function () {
    const clipPathObj = new fabric.Rect({
      width: this.width + this.strokeWidth * 2,
      height: this.height + this.strokeWidth * 2,
      top: -this.height / 2 - this.strokeWidth,
      left: -this.width / 2 - this.strokeWidth,
    });
    this.clipPath = clipPathObj;
  },
  toSVG() {
    this.updateClipPath();
    const { text, searchIcon } = this.createComponents();
    return this.callSuper('toSVG') + text.toSVG() + searchIcon.toSVG();
  },
  _render(ctx) {
    this.updateClipPath();
    const { text, searchIcon } = this.createComponents();
    this.set({ objectCaching: false, noScaleCache: false });
    this.callSuper('_render', ctx);
    text.render(ctx);
    searchIcon.render(ctx);
  },
});

fabric.RectTextSVG.fromObject = function (options, callback) {
  return callback(new fabric.RectTextSVG(options));
};

window.fabric.RectTextSVG = fabric.RectTextSVG;

export default fabric.RectTextSVG;

const arrowIcon = {
  name: 'Search Icon',
  path: 'M 9.4774 9.4866 L 12.6 12.6 M 10.8 6.3 c 0 2.4852 -2.0148 4.5 -4.5 4.5 C 3.8147 10.8 1.8 8.7852 1.8 6.3 C 1.8 3.8147 3.8147 1.8 6.3 1.8 C 8.7852 1.8 10.8 3.8147 10.8 6.3 Z',
  width: 14,
  height: 14,
  fill: 'transparent',
  strokeWidth: 1,
  opacity: 1,
  stroke: '#000',
  originX: 'center',
  originY: 'center',
  scaleX: 1,
  scaleY: 1,
};
export function createCustomObj() {
  const rect = new fabric.RectTextSVG({
    name: FABRIC_CUSTOM_OBJECT.rectTextSVG,
    width: 200,
    height: 400,
    strokeWidth: 1,
    fill: 'transparent',
    stroke: '#000000',
    textAlignHorizontal: 'center',
    textAlignVertical: 'center',
    textStyle: {
      left: 0,
      top: 0,
      name: 'TextBox',
      fill: '#000000',
      text: 'My text',
      originX: 'center',
      originY: 'center',
      textAlign: 'center',
      height: 10,
      objectCaching: false,
    },
    pathStyle: {
      ...arrowIcon,
      deltaX: 0,
      deltaY: 0,
      scaleX: 1,
      scaleY: 1,
      objectCaching: false,
      padding: 10,
    },
    id: generateId(),
  });
  return rect;
}
